import {CountryCodeEnum} from '../enums/country-code.enum';

export class CompanyModel {
    name: string;
    street: string;
    zip: string;
    city: string;
    country: string; // CountryCodeEnum;
}

